<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <v-expansion-panels class="px-2">
          <v-expansion-panel
            v-for="(post, index) in posts"
            :key="index"
            class="mt-2 rounded-lg"
          >
            <v-expansion-panel-header>
              <span>
                <span v-if="index !== editPostTitle">
                  {{ post.title }}
                </span>
                <div class="rowinfo" v-if="index === editPostTitle">
                  <v-text-field
                    v-if="index === editPostTitle"
                    v-model="post.title"
                    append-icon="check"
                    class="my-2 contnetinfo"
                    dark
                    dense
                    hide-details
                    :label="$t('title')"
                    outlined
                    @click.stop
                    @click:append.stop="editPostTitle = -1"
                  />
                  <help-info
                    v-show="index === 0"
                    :element-name="`${serviceName}-${componentName}-data-addvideo`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('title')"
                  />
                </div>
                <v-btn
                  v-if="index !== editPostTitle"
                  icon
                  small
                  @click.stop="editPostTitle = index"
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </span>
              <div class="rowinfo justify-end">
                <v-btn icon max-width="36" @click="posts.splice(index, 1)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
                <help-info
                  v-if="index !== editPostTitle && index === -1"
                  :element-name="`${serviceName}-${componentName}-data-editPostTitle`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('selected_services')"
                />
              </div>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <v-card class="mt-12 mb-4" flat>
                <custom-tabs v-model="tabs" grow>
                  <template v-slot:staticTabs>
                    <v-tab :ripple="false">
                      <div
                        class="d-flex row gap-0 align-center align-self-center align-items-center px-2"
                        style="
                          justify-content: center !important;
                          align-items: center;
                        "
                      >
                        <div class="cornel-left"></div>
                        <div class="cornel-right"></div>
                        <v-icon class="me-2">mdi-image</v-icon>
                        {{ $t("image") }}
                        <help-info
                          :element-name="`${serviceName}-${componentName}-tab-image-1`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          :label="$t('image')"
                        />
                      </div>
                    </v-tab>
                    <v-tab :ripple="false">
                      <div
                        class="d-flex row gap-0 align-center align-self-center align-items-center px-2"
                        style="
                          justify-content: center !important;
                          align-items: center;
                        "
                      >
                        <div class="cornel-left"></div>
                        <div class="cornel-right"></div>
                        <v-icon class="me-2">mdi-palette</v-icon>
                        {{ $t("color") }}
                        <help-info
                          :element-name="`${serviceName}-${componentName}-tab-image-1`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          :label="$t('color')"
                        />
                      </div>
                    </v-tab>
                    <v-tab :ripple="false">
                      <div
                        class="d-flex row gap-0 align-center align-self-center align-items-center px-2"
                        style="
                          justify-content: center !important;
                          align-items: center;
                        "
                      >
                        <div class="cornel-left"></div>
                        <div class="cornel-right"></div>
                        <v-icon class="me-2">mdi-label</v-icon>
                        {{ $t("icon") }}
                        <help-info
                          :element-name="`${serviceName}-${componentName}-tab-image-1`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          :label="$t('icon')"
                        />
                      </div>
                    </v-tab>
                  </template>
                  <template v-slot:staticItems>
                    <v-tabs-items v-model="tabs" class="mb-6" touchless>
                      <v-tab-item>
                        <pic-selector
                          :edit-name="false"
                          :field.sync="post.image"
                          one-pic
                          single
                          @change="resetOther(post, 'gallery', index)"
                        />
                      </v-tab-item>

                      <v-tab-item>
                        <color-pallete
                          v-model="post.color"
                          class="my-8"
                          @input="resetOther(post, 'color', index)"
                        />
                      </v-tab-item>

                      <v-tab-item class="mt-4">
                        <div class="rowinfo">
                          <icon-picker
                            v-model="post.icon"
                            @input="resetOther(post, 'icon', index)"
                            class="contentinfo"
                          />
                          <help-info
                            :element-name="`${serviceName}-${componentName}-serivce-link2`"
                            :service-name="serviceName"
                            :help-data="helpData"
                            class="buttoninfo"
                            :label="$t('add_new_post')"
                          />
                        </div>
                      </v-tab-item>
                    </v-tabs-items>
                  </template>
                </custom-tabs>
                <div class="rowinfo">
                  <v-text-field
                    v-model="post.link"
                    :rules="[rules.link]"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    class="contentinfo"
                    :label="$t('link')"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-post-link2`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('add_new_post')"
                  />
                </div>
                <div class="rowinfo">
                  <v-textarea
                    v-model="post.content"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    class="contentinfo"
                    :label="$t('description')"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-post-content2`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('add_new_services')"
                  />
                </div>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-card-actions class="px-2 pt-6">
          <div class="rowinfo" style="width: 100% !important">
            <v-btn
              color="success"
              outlined
              @click="addNewPost"
              class="contentinfo"
            >
              <v-icon>mdi-plus</v-icon>
              {{ $t("add_new_service") }}
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-addNewPost`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('add_new_service')"
            />
          </div>
        </v-card-actions>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import ColorPallete from "@/view/components/colorPallete";
import PicSelector from "@/view/components/UploadCenter/picSelector";
import PicSelectorSingle from "@/view/components/UploadCenter/picSelectorSingle";
import IconPicker from "@/view/components/IconPicker";

export default {
  name: "Service",

  components: { IconPicker, PicSelectorSingle, PicSelector, ColorPallete },

  props: {
    data: {
      type: Object,
      required: true,
    },
    value: Array,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "service-appointment",
      editPostTitle: -1,
      tabs: 0,
      posts: [],
    };
  },
  computed: {
    rules() {
      return {
        link: (value) =>
          this.isDomain(value) || this.$t("domain_must_be_https_or_http"),
      };
    },
  },

  mounted() {
    if (this.data?.service) this.posts = [...this.data.service];
    // this.posts = this.data.service;
    else if (!!this.value) this.posts = [...this.value];
    //  this.posts = this.value;
    else {
      this.posts = [
        {
          title: this.$t("post") + " 1",
          content: "",
          image: "",
          color: null,
          icon: null,
        },
      ];
      this.data["service"] = [...this.posts];
      this.$emit("input", this.posts);
    }
  },

  watch: {
    posts: {
      deep: true,
      handler(value) {
        if (!!this.value) this.$emit("input", value);
        else if (!!this.data) this.data["service"] = value;
      },
    },
    data: {
      deep: true,
      handler(newData) {
        if (
          newData?.service &&
          JSON.stringify(newData.service) !== JSON.stringify(this.posts)
        ) {
          this.posts = [...newData.service];
        }
      },
    },
    value: {
      deep: true,
      handler(val) {
        if (val?.length && JSON.stringify(val) !== JSON.stringify(this.posts)) {
          this.posts = [...val];
        }
      },
    },
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    addNewPost() {
      this.posts.push({
        title: this.$t("post") + " " + (this.posts.length + 1),
        content: "",
      });
    },
    resetOther(post, name, index) {
      const current = post[name];

      const newPost = {
        ...post,
        gallery:
          name === "icon" || name === "color"
            ? [{ name: "", images: [] }]
            : post.gallery,
        image: name === "icon" || name === "color" ? "" : post.image,
        icon: name === "gallery" ? null : post.icon,
        color: name === "gallery" ? null : post.color,
        [name]: current,
      };

      this.$set(this.posts, index, newPost);
    },
    isDomain(str) {
      var regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );
      var without_regex = new RegExp(
        "^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );

      return (
        !str || regex.test(str) || without_regex.test(str) || str.length <= 0
      );
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  border-bottom: 2px solid var(--v-primary-base);
}
</style>
